import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activityDirections"},[_c('div',[_c('center',[_c(VCard,{staticStyle:{"box-shadow":"2px 2px 20px rgba(0, 0, 0, 0.1)"},attrs:{"width":"40vw"}},[_c('center',{staticStyle:{"padding":"8px","font-style":"italic","font-size":"large","font-family":"Calibri"}},[_vm._v(" *Select an option from the left. ")])],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }